import { CategoryAttributes } from '@/types'
import { EditCategoryQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { UpdateCategoryMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { useContext } from 'react'
import { CurrentTenantContext } from '@/core/current_tenant_context'

type Category = EditCategoryQuery['categories']['nodes'][0]

interface Props {
  id: string
}

export const Form = ({ id }: Props) => {
  const {
    attributes,
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading
  } = useForm<UpdateCategoryMutation, CategoryAttributes, EditCategoryQuery, Category>({
    id,
    initializer: category => ({
      name: category.name,
      parentId: category.parent?.id,
      color: category?.parent ? null : category?.color || null,
      mystroTestId: category.mystroTestId || ''
    }),
    query: EditQuery,
    queryKey: 'categories',
    mutation: UpdateMutation,
    resultKey: 'updateCategory'
  })
  const { currentCompany } = useContext(CurrentTenantContext)

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
        { formBuilder.buildField({ name: 'Parent', field: 'parentId', type: 'category' }) }
        { !attributes.parentId && formBuilder.buildField({ name: 'Color', field: 'color', type: 'color' }) }
        { currentCompany?.mystroEnabled && formBuilder.buildField({ name: 'Default Mystro test', field: 'mystroTestId', type: 'mystro-test' }) }
        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
